import React from 'react';

const cardBg = '#111';
const cardBorder = '#1f1f1f';
const cardBorderSelected = 'rgba(220,38,38,0.4)';
const redGradient = '#dc2626';

const ListIcon = ({ size = 6 }) => (
  <svg className={`w-${size} h-${size} text-white opacity-80`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
  </svg>
);

function PlaylistCard({ item, isSelected, onSelect, onEdit, onDelete, viewMode }) {
  const formatDate = (dateString) => new Date(dateString).toLocaleDateString();

  if (viewMode === 'list') {
    return (
      <div className="flex items-center justify-between p-4 rounded-xl transition-all"
        style={{ background: cardBg, border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}` }}>
        <div className="flex items-center gap-4">
          <input type="checkbox" checked={isSelected} onChange={onSelect} className="w-4 h-4 rounded" style={{ accentColor: '#dc2626' }} />
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: redGradient }}>
              <ListIcon size={5} />
            </div>
            <div>
              <h3 className="font-bold text-white text-sm">{item.name}</h3>
              <div className="flex items-center gap-3 mt-0.5">
                <span className="text-xs" style={{ color: '#9ca3af' }}>{item.songs?.length || 0} songs</span>
                <span className="text-xs px-1.5 py-0.5 rounded font-medium" style={
                  item.is_public
                    ? { background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }
                    : { background: '#1a1a1a', color: '#6b7280', border: '1px solid #2a2a2a' }
                }>
                  {item.is_public ? 'Public' : 'Private'}
                </span>
                <span className="text-xs" style={{ color: '#6b7280' }}>{formatDate(item.created_at)}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex gap-2">
          <button onClick={onEdit} className="px-3 py-1.5 rounded-lg text-xs font-medium text-white" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>Edit</button>
          <button onClick={onDelete} className="px-3 py-1.5 rounded-lg text-xs font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>Delete</button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative rounded-xl p-5 transition-all"
      style={{ background: cardBg, border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}` }}>
      <div className="absolute top-3 left-3">
        <input type="checkbox" checked={isSelected} onChange={onSelect} className="w-4 h-4 rounded" style={{ accentColor: '#dc2626' }} />
      </div>

      <div className="flex flex-col items-center text-center pt-2">
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4" style={{ background: redGradient }}>
          <ListIcon size={8} />
        </div>

        <h3 className="font-black text-white text-base mb-1">{item.name}</h3>

        {item.description && (
          <p className="text-xs leading-relaxed line-clamp-2 mb-3" style={{ color: '#6b7280' }}>
            {item.description.substring(0, 100)}{item.description.length > 100 && '...'}
          </p>
        )}

        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs" style={{ color: '#9ca3af' }}>{item.songs?.length || 0} songs</span>
          <span className="text-xs px-2 py-0.5 rounded font-medium" style={
            item.is_public
              ? { background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }
              : { background: '#1a1a1a', color: '#6b7280', border: '1px solid #2a2a2a' }
          }>
            {item.is_public ? 'Public' : 'Private'}
          </span>
        </div>

        <p className="text-xs mb-5" style={{ color: '#4b5563' }}>{formatDate(item.created_at)}</p>

        <div className="flex gap-2 w-full">
          <button onClick={onEdit} className="flex-1 py-2 rounded-lg text-xs font-medium text-white" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>Edit</button>
          <button onClick={onDelete} className="flex-1 py-2 rounded-lg text-xs font-medium" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>Delete</button>
        </div>
      </div>
    </div>
  );
}

export default PlaylistCard;